import { z } from 'zod';
import { ELEMENTS } from '../../domain/game/elements';
import { FACTIONS } from '../../domain/game/factions';

const skillSchema = z
  .object({
  id: z.string().min(1),
  name: z.string().min(1),
  element: z.enum(ELEMENTS),
  faction: z.enum(FACTIONS),
  power: z.number().positive(),
  /** Physical skills: manaCost must be 0 (gameplay_ideas). */
  manaCost: z.number().nonnegative(),
  /** Base hit chance 0–1 before luck. */
    accuracy: z.number().min(0).max(1).default(0.9),
  })
  .refine((skill) => skill.element !== 'physical' || skill.manaCost === 0, {
    message: 'Physical skills must cost 0 mana',
  });

export type Skill = z.infer<typeof skillSchema>;

export const skills: Skill[] = z.array(skillSchema).parse([
  {
    id: 'slash',
    name: 'Trảm Kích',
    element: 'physical',
    faction: 'human',
    power: 8,
    manaCost: 0,
    accuracy: 0.92,
  },
  {
    id: 'gale',
    name: 'Phong Nhận',
    element: 'wind',
    faction: 'human',
    power: 12,
    manaCost: 8,
    accuracy: 0.88,
  },
  {
    id: 'ember',
    name: 'Hỏa Cầu',
    element: 'fire',
    faction: 'human',
    power: 15,
    manaCost: 11,
    accuracy: 0.85,
  },
  {
    id: 'tide',
    name: 'Thủy Lưu',
    element: 'water',
    faction: 'human',
    power: 11,
    manaCost: 9,
    accuracy: 0.9,
  },
  {
    id: 'spark',
    name: 'Lôi Tinh',
    element: 'lightning',
    faction: 'human',
    power: 14,
    manaCost: 12,
    accuracy: 0.84,
  },
  {
    id: 'radiant_bolt',
    name: 'Quang Tiễn',
    element: 'light',
    faction: 'human',
    power: 15,
    manaCost: 13,
    accuracy: 0.87,
  },
  {
    id: 'smite',
    name: 'Thánh Quang',
    element: 'light',
    faction: 'god',
    power: 16,
    manaCost: 14,
    accuracy: 0.86,
  },
]);

export function getSkillById(id: string): Skill | undefined {
  return skills.find((s) => s.id === id);
}

/** Skills the player may use (owned list). */
export function getOwnedSkills(ownedIds: readonly string[]): Skill[] {
  return ownedIds
    .map((id) => getSkillById(id))
    .filter((s): s is Skill => Boolean(s));
}
